import { CustomElement } from "../../core/CustomElement";

class CCCLink extends CustomElement {
  component: HTMLLinkElement = null;

  static get observedAttributes() {
    return ["href", "target"];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
    };
    this.setupComponent();
    this.component = this.shadowDom.querySelector("#ccc-link");
  }

  // Responder a los cambios en el atributo.
  // eslint-disable-next-line
  attributeChangedCallback(attr: string, oldValue: any, newValue: any) {
    if (attr == "href") {
      this.setKeyState("href", newValue);
    }
    if (attr == "target") {
      this.setKeyState("target", newValue);
    }
  }

  watchHref(): void {
    this.component.href = this.state.href;
  }

  watchTarget(): void {
    this.component.target = this.state.target;
  }
}

// define component
if (!customElements.get("ccc-link")) {
  customElements.define("ccc-link", CCCLink);
}
